import type { LastMilePickupConfig } from '../../../domain/types/configs/company/LastMilePickupConfig';

export const lastMilePickupConfig: LastMilePickupConfig = {
  lastMilePickUpLocation: [],
  showAll: true
}; 